export const SHARE_TYPES = {
  IMAGE_BANK: "IMAGE_BANK",
  FILE_VIEW: "FILE_VIEW",
};
